import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Card, ConfigProvider, Form, message, Pagination, Popover, Table, Input, Button, Space, Popconfirm, Typography, Tag, TimePicker, Spin, Modal } from 'antd'
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";
import { QuestionCircleOutlined } from '@ant-design/icons';
import moment from "moment";
import './GPPricingMatrix.css'
import axios from 'axios';
import dayjs from 'dayjs';
import { Editor } from '@tinymce/tinymce-react';
import { Config } from '../Common/Config';
const { Title } = Typography;

const getInitials = (name = '') => {
    const words = (name || '').trim().split(/\s+/).filter(Boolean);
    if (words.length >= 2) return (words[0][0] + words[1][0]).toUpperCase();
    if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
    return '?';
};

const GPPricingMatrix = () => {
    let userTempData = localStorage.getItem('userData'), userData = {}
    if (userTempData) {
        userData = JSON.parse(userTempData)
    }
    const userRole = userData?.roles?.[0]?.role_id;
    const isCSRandCSR_R = userRole === 2 || userRole === 3;

    const editorRef = useRef(null);
    const [form] = Form.useForm();
    const [clinicDataSetInUpdate, setclinicDataSet] = useState(null)
    const [selected, setSelected] = useState(null);
    const [editingRow, setEditingRow] = useState(null);
    const [durationObjectById, setdurationObjectById] = useState(null);
    const [editingBooking, seteditingBooking] = useState(null);
    const [clinics, setclinics] = useState([null]);
    const [clinicsShow, setclinicsShow] = useState(null);
    const [allClinicData, setallClinicData] = useState([])
    const [bookingPageCopy, setbookingPageCopy] = useState([])
    const [loader, setloader] = useState(false)
    const [loaderForclinics, setloaderForclinics] = useState(false)
    const [CurrentPage, setCurrentPage] = useState(1)
    const [showAddButton, setshowAddButton] = useState(true)
    const [eveningPrice, seteveningPrice] = useState(null)
    const [isClinicCreateEnable, setisClinicCreateEnable] = useState(false)
    const [isViewMode, setIsViewMode] = useState(false)
    const [isBookingViewMode, setIsBookingViewMode] = useState(false)
    const [messageApi, contextHolder] = message.useMessage();
    const hasFetched = useRef(false)

    useEffect(() => {
        if (!hasFetched.current) {
            getAllBucketsData()
            getAllBucketsBookingCopyData()
            hasFetched.current = true;
        }
    }, [CurrentPage])

    const getAllBucketsData = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}clinic-bucket-pricing`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response?.data?.data) {
                setallClinicData(response?.data?.data)

                hasFetched.current = false;
            } else {

            }
            setloader(false)
        } catch (error) {
            console.log('error in get clinic-bucket-pricing data ::::', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
            setloader(false)
        }
    }
    const getAllBucketsBookingCopyData = async () => {
        setloader(true)
        try {
            const response = await axios.get(`${Config.url}duration`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response?.data?.data) {
                // console.log(':::response?.data?.data::::::', response?.data?.data)
                let durationObject = {}
                if (response?.data?.data && response?.data?.data.length) {
                    response?.data?.data.map(duration => {
                        durationObject[duration.duration_id] = duration
                    })
                }
                // console.log(':::durationObject::::::', durationObject)
                setbookingPageCopy(response?.data?.data)
                setdurationObjectById(durationObject)
                hasFetched.current = false;
            } else {

            }
            setloader(false)
        } catch (error) {
            console.log('error in get clinic-bucket-pricing data ::::', error)
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message || "Something went wrong",
            });
            setloader(false)
        }
    }
    const getAllclinicbyBucketidData = async (id) => {
        if (!id) {
            return
        }
        try {
            const response = await axios.get(`${Config.url}clinic-bucket-pricing/${id}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response?.data?.data) {
                setclinics(response?.data?.data)
                if (response?.data?.data?.clinics && response?.data?.data.clinics.length) {
                    let clinicsShowTemp = []
                    // console.log('response?.data?.data.clinics::',response?.data?.data.clinics)
                    response?.data?.data.clinics.map(cli => {
                        if (cli && cli.status && cli.status == 1) {
                            clinicsShowTemp.push(cli)
                        }
                    })
                    if (clinicsShowTemp && clinicsShowTemp.length) {
                        setclinicsShow(clinicsShowTemp)
                    } else {
                        setclinicsShow([])
                    }
                } else if (response?.data?.data.clinics && response?.data?.data.clinics.length == 0) {
                    setclinicsShow([])
                }
            }
        } catch (error) {
            console.log(':::::::getAllclinicbyBucketidData::::::', error)
        }
        setloaderForclinics(false)
    }

    const columns = [
        {
            title: (
                <div style={{ textAlign: 'center', marginLeft: 150 }}>
                    All clinic buckets
                </div>
            ),
            dataIndex: 'bucket_name',
            key: 'bucket_name',
            render: (_, record) => (
                <div onClick={() => handleRowClick(record)}>
                    {record.bucket_name}
                </div>
            ),
        },
        {
            title: '',
            key: 'action',
            render: (_, record) => (
                <div style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                    <Popover placement="left" trigger="click" content={() => content(record)}>
                        <button
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                                color: '#008385', padding: '0 6px', lineHeight: 1,
                            }}
                        >···</button>
                    </Popover>
                </div>
            ),
        },
    ];
    const columnsBooking = [
        {
            title: '',
            dataIndex: 'duration',
            key: 'duration',
            render: (_, record) => (
                record.duration ? record.duration + ' minutes' : ''
            )
        },
        {
            title: 'Booking page copy',
            dataIndex: 'content',
            key: 'content',
            render: (text, record, index) => {
                return (
                    <div dangerouslySetInnerHTML={{ __html: record.content }} />

                )
            }

        },
        {
            title: '',
            key: 'action',
            render: (_, record) => (
                <div className='action-cell' style={{ textAlign: 'right' }} onClick={(e) => e.stopPropagation()}>
                    <Popover placement="left" trigger="click" content={() => content2(record)}>
                        <button
                            onClick={(e) => e.stopPropagation()}
                            style={{
                                background: 'none', border: 'none', cursor: 'pointer',
                                fontWeight: 700, fontSize: 18, letterSpacing: 2,
                                color: '#008385', padding: '0 6px', lineHeight: 1,
                            }}
                        >···</button>
                    </Popover>
                </div>
            ),
        },
    ];

    const content2 = (record) => {
        return (
            <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setloader(true)
                        setIsBookingViewMode(true)
                        seteditingBooking(record)
                        setclinicDataSet(record)
                        form.setFieldsValue(record);
                        setData(record)
                        setloader(false)
                    }}
                >
                    <EyeOutlined style={{ fontSize: 15 }} /> View
                </div>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setloader(true)
                        setIsBookingViewMode(false)
                        seteditingBooking(record)
                        setclinicDataSet(record)
                        form.setFieldsValue(record);
                        setData(record)
                        setloader(false)
                    }}
                >
                    <EditOutlined style={{ fontSize: 15 }} /> Edit
                </div>
            </div>
        )
    };
    const content = (record) => {
        return (
            <div className="rule-action-popover" style={{ display: 'flex', flexDirection: 'column', padding: '4px 0' }}>
                <div
                    className="rule-action-item"
                    style={{ color: '#008385' }}
                    onClick={(e) => {
                        e.stopPropagation()
                        setshowAddButton(false)
                        setisClinicCreateEnable(true)
                        setIsViewMode(true)
                        setloader(true)
                        if (record.id) { getAllclinicbyBucketidData(record.id) }
                        if (record.evening_price_starts_at) {
                            let date = /(\d{1,2}:\d{2} (AM|PM))/i.test(record.evening_price_starts_at), newDate = '';
                            if (!date && newDate == '') {
                                newDate = record.evening_price_starts_at ? moment(record.evening_price_starts_at, "HH:mm").format("HH:mm") : null
                                seteveningPrice(newDate)
                            } else { seteveningPrice(record.evening_price_starts_at) }
                        }
                        setclinicDataSet(record)
                        form.setFieldsValue(record);
                        setData(record)
                        setloader(false)
                        document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
                    }}
                >
                    <EyeOutlined style={{ fontSize: 15 }} /> View
                </div>
                {!isCSRandCSR_R && (
                    <>
                        <div
                            className="rule-action-item"
                            style={{ color: '#008385' }}
                            onClick={(e) => {
                                e.stopPropagation()
                                setshowAddButton(false)
                                setisClinicCreateEnable(true)
                                setIsViewMode(false)
                                setloader(true)
                                if (record.id) { getAllclinicbyBucketidData(record.id) }
                                if (record.evening_price_starts_at) {
                                    let date = /(\d{1,2}:\d{2} (AM|PM))/i.test(record.evening_price_starts_at), newDate = '';
                                    if (!date && newDate == '') {
                                        newDate = record.evening_price_starts_at ? moment(record.evening_price_starts_at, "HH:mm").format("HH:mm") : null
                                        seteveningPrice(newDate)
                                    } else { seteveningPrice(record.evening_price_starts_at) }
                                }
                                setclinicDataSet(record)
                                form.setFieldsValue(record);
                                setData(record)
                                setloader(false)
                                document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
                            }}
                        >
                            <EditOutlined style={{ fontSize: 15 }} /> Edit
                        </div>
                        <div className="rule-action-divider" />
                        <Popconfirm
                            title="Delete"
                            className='confirmation-popup'
                            description="Are you sure you want to delete?"
                            onCancel={() => deleteUser(record)}
                            okText="No"
                            cancelText="Yes"
                            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
                            okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                            cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                        >
                            <div className="rule-action-item rule-action-item--delete" onClick={(e) => e.stopPropagation()}>
                                <DeleteOutlined style={{ fontSize: 15 }} /> Delete
                            </div>
                        </Popconfirm>
                    </>
                )}
            </div>
        )
    };
    // const showConfirm = (record) => {
    //     console.log('record ',record)
    //  return   Modal.confirm({
    //         title: 'Delete',
    //         icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
    //         content: 'Are you sure you want to delete?',
    //         okText: 'Yes',
    //         cancelText: 'No',
    //         onOk: () => deleteUser(record),
    //         onCancel: () => console.log('Cancel clicked'),
    //         className: 'custom-confirm-modal',
    //     });
    // }
    const deleteUser = async (record) => {
        let url = `${Config.url}clinic-bucket-pricing/${record.id}`
        try {
            const response = await axios.delete(url, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`,
                },
            })
            messageApi.success({
                type: 'succes',
                content: 'Bucket deleted successfully',
            });
            getAllBucketsData()
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: error.response?.data?.message || error.message ? error.response?.data?.message || error.message : 'Something went Wrong',
            });
            console.log('update :', error.response?.data?.message || error.message);
        }
    }
    const itemRender = (_, type, originalElement) => {
        if (type === 'prev') {
            return <a style={{ color: '#4A4A4A' }}>Previous</a>;
        }
        if (type === 'next') {
            return <a style={{ color: '#4A4A4A' }}>Next</a>;
        }
        return originalElement;
    };
    const onDateChange = (time, timeString) => {
        const date = moment(time);
        // console.log('time, timeString', timeString);
        seteveningPrice(timeString)
    };
    const onFinish = async (values, update = false) => {

        // console.log('::values::::', { eveningPrice, values })
        // return
        if (!eveningPrice) {
            messageApi.error({
                type: 'error',
                content: 'Add Evening prices start at',
            });
            return
        }
        setloader(true)
        // return
        if (!update) {
            let payload = {
                bucket_name: values.bucket_name,
                evening_price_starts_at: eveningPrice ?? undefined,
                clinic_bucket_pricings: values.clinic_bucket_pricings && Object.values(values.clinic_bucket_pricings) ? Object.values(values.clinic_bucket_pricings) : undefined
            }
            try {
                const response = await axios.post(`${Config.url}clinic-bucket-pricing`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                messageApi.success({
                    type: 'succes',
                    content: 'Bucket Created successfully',
                });
                form.setFieldsValue({
                    "bucket_name": '',
                    evening_price_starts_at: '',
                    "clinic_bucket_pricings": []
                });
                setloader(false)
                getAllBucketsData()
                setisClinicCreateEnable(false)
                setshowAddButton(true)
            } catch (error) {
                messageApi.error({
                    type: 'error',
                    content: error.response?.data?.message || error.message || 'Something Went wrong',
                });
                console.log('create user:', error.response?.data || error.message);
            }

        } else {
            if (!clinicDataSetInUpdate.id) {
                setloader(false)
                return
            }
            try {


                let url = `${Config.url}clinic-bucket-pricing/${clinicDataSetInUpdate.id}`, rooms = []

                let payload = {
                    bucket_name: values.bucket_name,
                    evening_price_starts_at: eveningPrice ?? undefined,
                    clinic_bucket_pricings: values.clinic_bucket_pricings && Object.values(values.clinic_bucket_pricings) ? Object.values(values.clinic_bucket_pricings) : undefined
                }
                const response = await axios.put(url, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                });
                setclinicDataSet({})
                setloader(false)
                getAllBucketsData()
                getAllclinicbyBucketidData(clinicDataSetInUpdate.id)
                setisClinicCreateEnable(false)
                setshowAddButton(true)
                messageApi.success({
                    type: 'succes',
                    content: 'Bucket updated successfully',
                });
            } catch (error) {
                messageApi.error({
                    type: 'error',
                    content: error.response?.data?.message || error.message || 'Something Went wrong',
                });
                console.log('create user:', error.response?.data, error.message);
            }
        }

        setloader(false)
        seteveningPrice(undefined)
        setIsViewMode(false)
    }

    const [data, setData] = useState({
        bucket_name: '', evening_price_starts_at: '10:00', clinic_bucket_pricings: [
            { id: "1", duration_id: "1", normal_price: "", evening_price: "", bank_holiday_price: "", booking_page_copy: "" },
            { id: "2", duration_id: "2", normal_price: "", evening_price: "", bank_holiday_price: "", booking_page_copy: "" },
            { id: "3", duration_id: "3", normal_price: "", evening_price: "", bank_holiday_price: "", booking_page_copy: "" },
            { id: "4", duration_id: "4", normal_price: "", evening_price: "", bank_holiday_price: "", booking_page_copy: "" },
        ]
    });
    useEffect(() => {
        const initialValues = {
            bucket_name: data.bucket_name,
            evening_price_starts_at: moment(data.evening_price_starts_at, "HH:mm") || undefined,
            clinic_bucket_pricings: data?.clinic_bucket_pricings?.reduce((acc, item) => {
                acc[item.id] = {
                    duration_id: item.duration_id,
                    normal_price: parseFloat(item.normal_price) || "",
                    evening_price: parseFloat(item.evening_price) || "",
                    bank_holiday_price: parseFloat(item.bank_holiday_price) || "",
                    booking_page_copy: item.booking_page_copy || "",
                };
                return acc;
            }, {})
        };
        form.setFieldsValue(initialValues);
    }, [data, form]);
    const columns1 = [
        {
            title: (<div style={{ marginLeft: 15 }}>
                Duration
            </div>),
            dataIndex: "duration_id",
            key: "duration_id",
            width: 110,
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Form.Item
                        name={["clinic_bucket_pricings", String(record.id), "duration_id"]}
                        initialValue={record.duration_id}

                    >
                        {/* {console.log(':::', record)} */}
                        {/* <Input
                        // disabled
                        // initialValue={durationObjectById && durationObjectById[record.duration_id] && durationObjectById[record.duration_id].duration ? durationObjectById[record.duration_id].duration : ''}
                            style={{
                                // border: "none",
                                // background: "transparent",
                                // pointerEvents: "none",
                                // fontSize: "14px",
                                // width: "60px",
                            }}
                        /> */}

                        {durationObjectById && durationObjectById[record.duration_id] && durationObjectById[record.duration_id].duration ? durationObjectById[record.duration_id].duration + ' minutes:' : ''}
                    </Form.Item>
                </div>
            ),
        },
        {
            title: "Normal price",
            dataIndex: "normal_price",
            key: "normal_price",
            width: 135,
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <label style={{ marginTop: 4, marginRight: 4 }}>
                        {'£'}
                    </label>
                    <Form.Item
                        style={{ display: 'flex', justifyContent: 'center' }}
                        name={["clinic_bucket_pricings", String(record.id), "normal_price"]}
                        rules={[{ required: !isViewMode, message: "Normal price is required." }, { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid number (e.g., 10 or 10.99)" }]}
                    >
                        {isViewMode ? (
                            <span>
                                {form.getFieldValue(["clinic_bucket_pricings", String(record.id), "normal_price"]) || record.normal_price || ''}
                            </span>
                        ) : (
                            <Input disabled={isViewMode} style={{ width: "60px", background: "#f0fdf4" }} />
                        )}
                    </Form.Item>
                </div>
            ),
        },
        {
            title: (
                <div style={{ textAlign: "center" }}>
                    <label>
                        Evening price <br />
                        <span style={{ fontSize: "12px", fontWeight: "normal" }}>
                            Evening prices start at: {' '}
                        </span>
                    </label>
                    <Space wrap>
                        {/* <Form.Item
                        name="evening_price_starts_at"
                        rules={[{ required: true, message: "Required" }]}
                        style={{ marginBottom: 0, marginTop: 8 }}
                    > */}
                        {isViewMode ? (
                            <span >{eveningPrice || ''}</span>
                        ) : (
                            <TimePicker
                                disabled={isViewMode}
                                // format="hh:mm A" // 12-hour format with AM/PM
                                // value={eveningPrice ? dayjs(eveningPrice, 'hh:mm') : undefined}
                                format="HH:mm" // 24-hour format
                                value={eveningPrice ? dayjs(eveningPrice, 'HH:mm') : undefined}
                                // use12Hours
                                // format="h:mm "
                                minuteStep={15}
                                onChange={onDateChange}
                                style={{ width: "120px", height: '28px', color: '#008385' }}
                            />
                        )}
                        {/* </Form.Item> */}
                    </Space>
                </div>
            ),
            dataIndex: "evening_price",
            key: "evening_price",
            width: 410,
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <label style={{ marginTop: 4, marginRight: 4 }}>
                        {'£'}
                    </label>
                    <Form.Item
                        style={{ display: 'flex', justifyContent: 'center' }}
                        name={["clinic_bucket_pricings", String(record.id), "evening_price"]}
                        rules={[{ required: !isViewMode, message: "Evening price is required." }, { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid number (e.g., 10 or 10.99)" }]}
                    >
                        {isViewMode ? (
                            <span >
                                {form.getFieldValue(["clinic_bucket_pricings", String(record.id), "evening_price"]) || record.evening_price || ''}
                            </span>
                        ) : (
                            <Input disabled={isViewMode} style={{ width: "60px", background: "#f0fdf4" }} />
                        )}
                    </Form.Item>
                </div>
            ),
        },
        {
            title: "Weekend and bank holiday price",
            dataIndex: "bank_holiday_price",
            key: "bank_holiday_price",
            width: 255,
            render: (_, record) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <label style={{ marginTop: 4, marginRight: 4 }}>
                        {'£'}
                    </label>
                    <Form.Item
                        style={{ display: 'flex', justifyContent: 'center' }}
                        name={["clinic_bucket_pricings", String(record.id), "bank_holiday_price"]}
                        rules={[{ required: !isViewMode, message: "Weekend and bank holiday price is required." }, { pattern: /^\d+(\.\d{1,2})?$/, message: "Enter a valid number (e.g., 10 or 10.99)" }]}
                    >
                        {isViewMode ? (
                            <span >
                                {form.getFieldValue(["clinic_bucket_pricings", String(record.id), "bank_holiday_price"]) || record.bank_holiday_price || ''}
                            </span>
                        ) : (
                            <Input disabled={isViewMode} style={{ width: "60px", background: "#f0fdf4" }} />
                        )}
                    </Form.Item>
                </div>
            ),
        },
        // {
        //     title: "Booking page copy",
        //     dataIndex: "booking_page_copy",
        //     key: "booking_page_copy",
        //     width: 255,
        //     render: (text, record) => (
        //         <div style={{ display: 'flex', justifyContent: 'center' }}>
        //             <Form.Item style={{ display: 'flex', justifyContent: 'center' }} name={["clinic_bucket_pricings", String(record.id), "booking_page_copy"]} rules={[{ required: true, message: "Required" }]}>
        //                 <Input.TextArea autoSize={{ minRows: 1, maxRows: 3 }} disabled={editingRow === record.id ? false : true} />
        //             </Form.Item>
        //             <EditOutlined
        //                 style={{ cursor: "pointer", marginLeft: "8px" }}
        //                 onClick={() => setEditingRow(editingRow === record.id ? null : record.id)}
        //             />
        //         </div>
        //     ),
        // },
    ];
    const setClinicDatainForm = (data) => {
        if (!data) {
            return
        }

        setSelected(data)
    }
    const handleRowClick = (record) => {
        setshowAddButton(false)
        setisClinicCreateEnable(true)
        setIsViewMode(true)
        setloader(true)
        if (record.id) {
            getAllclinicbyBucketidData(record.id)
        }
        if (record.evening_price_starts_at) {
            let date = /(\d{1,2}:\d{2} (AM|PM))/i.test(record.evening_price_starts_at), newDate = '';
            if (!date && newDate == '') {
                newDate = record.evening_price_starts_at ? moment(record.evening_price_starts_at, "HH:mm").format("HH:mm") : null
                seteveningPrice(newDate)
            } else {
                seteveningPrice(record.evening_price_starts_at)
            }
        }
        setclinicDataSet(record)
        form.setFieldsValue(record);
        setData(record)
        setloader(false)
        document.querySelector(".clinicCreate-form")?.scrollIntoView({ behavior: "smooth" });
    }
    const handleRowClickForBooking = (record) => {
        setshowAddButton(false)
        setloader(true)
        setIsBookingViewMode(true)
        seteditingBooking(record)
        setclinicDataSet(record)
        form.setFieldsValue(record);
        setData(record)
        setloader(false)
    }
    const updateBookingpageCopy = async (editingBooking, editingText) => {
        const content = editorRef.current.getContent();
        // console.log('Submitted content:', content);
        if (!content) {
            return
        }
        if (!editingBooking.duration_id) {
            return
        }
        try {


            let url = `${Config.url}duration/${editingBooking.duration_id}`, rooms = []
            let payload = {
                content: content,
            }

            const response = await axios.put(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            if (response) {
                seteditingBooking(null)
                getAllBucketsBookingCopyData()
            }
        } catch (error) {
            messageApi.error({
                type: 'error',
                content: error.response?.data || error.message || 'Something Went wrong',
            });
            console.log('duration update error:', error.response?.data || error.message);
        }
        // You can save or post this content to API here
    };

    const handleCancel = () => {
        // console.log('Cancelled');
        seteditingBooking(null)
        setIsBookingViewMode(false)
        // Maybe reset the editor or close modal
    };

    return (
        <App>
            {contextHolder}
            {!isCSRandCSR_R && (
                <>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Card
                    className='addClinic-table'
                    style={{ width: 937, margin: 0, padding: 0, borderRadius: 30, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
                >
                    <ConfigProvider
                        theme={{
                            components: {
                                Table: {
                                    headerBg: "#008385",
                                    headerColor: "#ffffff",
                                },
                                Spin: {
                                    colorPrimary: "#008385", // Change this to your desired color
                                },
                            },
                        }}
                    >
                        <Table
                            className='center-table'
                            loading={loader}
                            columns={columnsBooking}
                            dataSource={bookingPageCopy}
                            pagination={false}
                            rowClassName="selectRow"
                            onRow={(record) => ({ onClick: () => handleRowClickForBooking(record) })}


                            scroll={{
                                x: 'auto',
                                y: 330,
                            }}
                        />
                        {allClinicData && allClinicData?.total ? <Pagination
                            align="center"
                            defaultCurrent={1}
                            defaultPageSize={10}
                            total={allClinicData?.total}
                            onChange={(val, filter) => {
                                setCurrentPage(val)
                            }}
                            itemRender={itemRender}
                        /> : ''}
                    </ConfigProvider>
                </Card>
            </div>
            {editingBooking && <div style={{ display: 'grid', justifyContent: 'center', marginTop: 30 }}>
                <div style={{ textAlign: 'left', alignItems: 'flex-start', color: '#4a4a4a', marginBottom: 4, fontSize: 15 }}>
                    Booking page copy
                </div>
                {isBookingViewMode ? (
                    <div style={{ height: 300, width: 704, border: '1px solid #0c0c0c', borderRadius: '6px', padding: '10px', overflow: 'auto' }} dangerouslySetInnerHTML={{ __html: editingBooking.content }} />
                ) : (
                    <Editor
                        apiKey={Config.apiKey}
                        onInit={(_evt, editor) => editorRef.current = editor}
                        initialValue={editingBooking.content}
                        init={{
                            height: 300,
                            width: 704,
                            menubar: false,
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar: 'undo redo | blocks ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'removeformat ' + 'link | unlink',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }',
                            placeholder: 'Booking page copy'
                        }}
                    />
                )}
                <Space style={{ marginTop: 16 }}>
                    {isBookingViewMode ? (
                        <Button className='hoverGreen' type="primary" onClick={() => setIsBookingViewMode(false)}>
                            Edit
                        </Button>
                    ) : (
                        <Button className='hoverGreen' type="primary" onClick={() => updateBookingpageCopy(editingBooking)}>
                            Save
                        </Button>
                    )}
                    <Button onClick={handleCancel}>Cancel</Button>
                </Space>
            </div>}
                </>
            )}
            <div style={{ display: 'grid', justifyContent: 'center', marginTop: 30 }}>
                <div style={{ display: 'flex' }}>
                    {allClinicData && <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", marginBottom: "10px" }}>
                        <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20 }}>
                            All clinic buckets <span style={{ color: "black", fontWeight: '400' }}>({allClinicData?.total ? allClinicData.total : '00'})</span>
                        </Title>
                    </div>}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card
                        className='addClinic-table'
                        style={{ width: 937, margin: 0, padding: 0, borderRadius: 30, boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)" }}
                    >
                        <ConfigProvider
                            theme={{
                                components: {
                                    Table: {
                                        headerBg: "#008385",
                                        headerColor: "#ffffff",
                                    },
                                    Spin: {
                                        colorPrimary: "#008385", // Change this to your desired color
                                    },
                                },
                            }}
                        >
                            <Table
                                loading={loader}
                                columns={columns}
                                dataSource={allClinicData?.data}
                                pagination={false}
                                rowClassName="selectRow"


                                scroll={{
                                    x: 'auto',
                                    y: 330,
                                }}
                            />
                            {allClinicData && allClinicData?.total ? <Pagination
                                align="center"
                                defaultCurrent={1}
                                defaultPageSize={10}
                                total={allClinicData?.total}
                                onChange={(val, filter) => {
                                    setCurrentPage(val)
                                }}
                                itemRender={itemRender}
                            /> : ''}
                        </ConfigProvider>
                    </Card>
                </div>
            </div>
            {clinicsShow ? <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
                <Card className='addClinic-table' style={{ width: 937, textAlign: "center", borderRadius: 30 }}>
                    <Title level={4} style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0 }}>
                        {clinics && clinics.bucket_name ? clinics.bucket_name : 'bucket 01'}
                    </Title>
                    {loaderForclinics ? <Spin className="custom-spinner" /> : <div style={{ padding: "20px", display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "center" }}>
                        {clinicsShow && clinicsShow && clinicsShow.length ? clinicsShow?.map((clinic) => (
                            <Tag
                                key={clinic}
                                color={selected === clinic ? "#F0FAFA" : "rgba(0,0,0,0.1)"}
                                onClick={() => setClinicDatainForm(clinicsShow)}
                                style={{
                                    padding: "8px 15px",
                                    fontSize: "16px",
                                    fontWeight: 400,
                                    borderRadius: "15px",
                                    color: '#4A4A4A',
                                    cursor: "pointer",
                                    backgroundColor: '#F0FAFA',
                                    lineHeight: 1,
                                    border: selected === clinic ? "1px solid #008385" : "none"
                                }}
                            >
                                {clinic.name}
                            </Tag>
                        )) : 'No Data'}
                    </div>}
                </Card>
            </div> : ''}
            {showAddButton && <div className='clinicCreate-form ' style={{ display: 'flex', justifyContent: 'flex-start', marginTop: 20, marginLeft: '18%' }}>
                <Button className='add-generic-btn' onClick={() => {
                    setIsViewMode(false)
                    setisClinicCreateEnable(true)
                }}>
                    Add a bucket
                </Button>
            </div>}

            {isClinicCreateEnable && <div style={{ display: 'flex', justifyContent: 'center', marginTop: 40 }}>
                <div
                    style={{
                        width: 937,
                        margin: "auto",
                        background: "#FFFFFF",
                        padding: "0",
                        borderRadius: "10px",
                        boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    {/* View mode header */}
                    {isViewMode ? (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: 12, padding: '14px 24px 10px',
                            background: 'linear-gradient(90deg, #f0fafa 0%, #e6f5f5 100%)',
                            borderRadius: '10px 10px 0 0', borderBottom: '2px solid #c5e8e8'
                        }}>
                            <div style={{
                                width: 36, height: 36, borderRadius: '50%',
                                background: 'linear-gradient(135deg, #008385, #00a3a5)',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                color: '#fff', fontWeight: 700, fontSize: 14, flexShrink: 0,
                                boxShadow: '0 2px 6px rgba(0,131,133,0.30)',
                            }}>
                                {getInitials(clinicDataSetInUpdate?.bucket_name)}
                            </div>
                            <span style={{ fontWeight: 700, fontSize: 16, color: '#007a7c' }}>
                                {clinicDataSetInUpdate?.bucket_name}
                            </span>
                        </div>
                    ) : (
                        <div
                            style={{
                                background: "#008385",
                                color: "#fff",
                                padding: "10px",
                                textAlign: "center",
                                borderRadius: "10px 10px 0 0",
                                margin: '24px 24px 0 24px',
                                fontSize: "16px",
                                fontWeight: "bold",
                                boxShadow: "0px 3px 5px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            Bucket prices (£)
                        </div>
                    )}

                    {/* Table Component */}
                    {data && <Form
                        form={form}
                        layout="vertical"
                        onFinish={(values) => onFinish(values, clinicDataSetInUpdate && clinicDataSetInUpdate.id && Object.keys(clinicDataSetInUpdate)?.length ? true : false)}
                    >
                        <Space.Compact style={{ width: "100%" }}>
                            <Form.Item
                                name="bucket_name"
                                style={{ flex: "none", marginTop: 10, marginBottom: 10 }}
                                rules={[{ required: !isViewMode, message: "Bucket name is required." }]}
                            >
                                {isViewMode ? (
                                    <span style={{ fontWeight: 'bold', marginLeft: '25px' }}>{form.getFieldValue('bucket_name') || ''}</span>
                                ) : (
                                    <Input disabled={isViewMode} placeholder="Bucket Name" style={{ width: "100%", marginLeft: '24px' }} />
                                )}
                            </Form.Item>
                        </Space.Compact>

                        <Table
                            columns={columns1}
                            dataSource={data?.clinic_bucket_pricings}
                            pagination={false}
                            bordered
                            style={{ margin: '0 24px 0 24px', }}
                        />

                        {/* Buttons loading={loader} */}
                        <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                            {isViewMode ? (
                                <>
                                    <Button key="cancel-view-btn" htmlType="button" className="add-generic-btn" style={{ width: "93px", height: 40 }} onClick={(e) => {
                                        e.preventDefault()
                                        form.setFieldsValue({ "bucket_name": '', evening_price_starts_at: '', "clinic_bucket_pricings": [] });
                                        setclinicDataSet(undefined)
                                        setshowAddButton(true)
                                        setisClinicCreateEnable(false)
                                        setIsViewMode(false)
                                    }}>
                                        Cancel
                                    </Button>
                                    {!isCSRandCSR_R && (
                                        <Button
                                            key="edit-btn"
                                            htmlType="button"
                                            className="edit-btn-green"
                                            icon={<EditOutlined />}
                                            onClick={(e) => {
                                                e.preventDefault()
                                                setIsViewMode(false)
                                            }}
                                            style={{ width: 93, height: 40 }}
                                        >
                                            Edit
                                        </Button>
                                    )}
                                </>
                            ) : (
                                <>
                                    <Button key="cancel-edit-btn" htmlType="button" className="add-generic-btn" style={{ width: "93px", height: 40 }} onClick={(e) => {
                                        e.preventDefault()
                                        form.setFieldsValue({
                                            "bucket_name": '',
                                            evening_price_starts_at: '',
                                            "clinic_bucket_pricings": []
                                        });
                                        setclinicDataSet(undefined)
                                        setshowAddButton(true)
                                        setisClinicCreateEnable(false)
                                        setIsViewMode(false)
                                    }}>
                                        Cancel
                                    </Button>
                                    <Button
                                        key="apply-btn"
                                        type="primary"
                                        htmlType="submit"
                                        loading={loader}
                                        disabled={loader}
                                        style={{
                                            width: 93, height: 40,
                                            background: loader ? '#80bebe' : '#008385',
                                            borderColor: loader ? '#80bebe' : '#008385',
                                            cursor: loader ? 'not-allowed' : 'pointer',
                                        }}
                                    >
                                        {loader ? 'Saving...' : 'Apply'}
                                    </Button>
                                </>
                            )}
                        </div>
                    </Form>}
                    <div style={{ marginTop: 10 }}>{' '}</div>
                </div>
            </div>}

        </App>
    )
}

export default GPPricingMatrix
